"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Epsilon Page Changer
 */
var EpsilonPageChanger = /** @class */ (function () {
    /**
     * Basic Constructor
     *
     * @param control
     */
    function EpsilonPageChanger(control) {
        this.control = control;
        this.startSelectize();
        this.handleEvents();
    }
    /**
     * Initiate the selectize library
     */
    EpsilonPageChanger.prototype.startSelectize = function () {
        /**
         * Instantiate the selectize javascript plugin
         * and the input type number
         */
        try {
            this.control.container.find('select').selectize();
        }
        catch (err) {
            /**
             * In case the selectize plugin is not loaded, raise an error
             */
            console.warn('selectize not yet loaded');
        }
    };
    /**
     * Handle menu change
     */
    EpsilonPageChanger.prototype.handleEvents = function () {
        this.control.container.on('change', 'select', function (event) {
            wp.customize.previewer.previewUrl.set(jQuery(event.target).val());
        });
    };
    return EpsilonPageChanger;
}());
exports.EpsilonPageChanger = EpsilonPageChanger;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/controls/page-changer.ts
// module id = 43
// module chunks = 0